export function parseMMDDYYYY(v: unknown): Date | null {
  if (typeof v !== "string") return null;
  const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(v.trim());
  if (!m) return null;
  const mm = +m[1],
    dd = +m[2],
    yyyy = +m[3];
  if (mm < 1 || mm > 12) return null;

  const d = new Date(yyyy, mm - 1, dd);
  return d.getFullYear() === yyyy &&
    d.getMonth() === mm - 1 &&
    d.getDate() === dd
    ? new Date(yyyy, mm - 1, dd)
    : null;
}

export function toLocalDate(d: Date | null): Date | null {
  return d ? new Date(d.getFullYear(), d.getMonth(), d.getDate()) : null;
}

export function toDateOrNull(v: unknown): Date | null {
  if (!v) return null;

  if (v instanceof Date && !isNaN(v.getTime())) {
    return v;
  }

  if (typeof v === "string" || typeof v === "number") {
    const d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }

  return null;
}

export function atMidnight(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function computeMinDate(
  fieldValue?: string | Date | null,
  compare = true
): Date {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let base: Date | null = null;

  if (fieldValue instanceof Date && !isNaN(fieldValue.getTime())) {
    base = new Date(
      fieldValue.getFullYear(),
      fieldValue.getMonth(),
      fieldValue.getDate()
    );
  } else if (typeof fieldValue === "string" && fieldValue.trim() !== "") {
    const parsed = parseMMDDYYYY(fieldValue) ?? new Date(fieldValue);
    if (!isNaN(parsed.getTime())) {
      base = new Date(
        parsed.getFullYear(),
        parsed.getMonth(),
        parsed.getDate()
      );
    }
  }

  if (base) {
    base.setHours(0, 0, 0, 0);
  } else {
    base = new Date(today);
  }

  if (!compare) {
    return base;
  } else {
    return base.getTime() > today.getTime() ? today : base;
  }
}
